window.$hxClasses = window.$hxClasses || {};
window.$estr = function() {
  return js.Boot.__string_rec(this, "")
};

$hxClasses.registerClass = function(aClass, name){
	if (aClass && name) {
		/** @private @type {Array} */
		aClass.__name__ = name.split('.'); // TODO: this not working on the OBF L3, need to be rework
		$hxClasses[name] = aClass;
	}
};


$hxClasses.extend = function(BaseClass, SubClass, subName) {
	$hxClasses.registerClass(SubClass, subName);
	if (BaseClass != null) {
		/** @private @type {Function} */
		SubClass.__super__ = BaseClass; // TODO: this not working on the OBF L3, need to be rework
		SubClass.prototype = $extend(BaseClass.prototype);
		SubClass.prototype.constructor = SubClass;
	}
    SubClass.prototype.callSuper = $hxClasses.callSuper;
};

/**
 * Convenience method for calling the superclass's implementation of a
 * method, with the current object bound as "this".
 *
 * Example:
 *
 *     Subclass.prototype.foo = function(x) {
 *         this.callSuper("foo")(x);        // Calls superclass's "foo" method, passing x as the argument.
 *         // Then do subclass stuff.
 *     }
 *
 * @param {String} methodName - The name of the method to call in the superclass.
 * return {Function} 
 */
$hxClasses.callSuper = function(methodName) {
    var me = this;
    return function() {
        me.constructor.__super__.prototype[methodName].apply(me, arguments);
    };
};

window.$extend = function $extend(from, fields) {
	var proto = Object.create(from);
	for (var name in fields) {
		proto[name] = fields[name];
	}
	return proto;
}

window.$closure = function $closure(o,f) {var m = o[f];if(m == null) return null;var f1 = function() {return m.apply(o,arguments);};f1.scope = o;f1.method = m;return f1;}
window.$noop = function $noop(){}
window.ValueType = $hxClasses['ValueType'] = { __ename__ : ["ValueType"], __constructs__ : ["TNull","TInt","TFloat","TBool","TObject","TFunction","TClass","TEnum","TUnknown"] };
ValueType.TInt = ["TInt",1];
ValueType.TInt.toString = $estr;
ValueType.TInt.__enum__ = ValueType;
ValueType.TUnknown = ["TUnknown",8];
ValueType.TUnknown.toString = $estr;
ValueType.TUnknown.__enum__ = ValueType;
ValueType.TFunction = ["TFunction",5];
ValueType.TFunction.toString = $estr;
ValueType.TFunction.__enum__ = ValueType;
ValueType.TNull = ["TNull",0];
ValueType.TNull.toString = $estr;
ValueType.TNull.__enum__ = ValueType;
ValueType.TEnum = function(e) { var $x = ["TEnum",7,e]; $x.__enum__ = ValueType; $x.toString = $estr; return $x; };
ValueType.TFloat = ["TFloat",2];
ValueType.TFloat.toString = $estr;
ValueType.TFloat.__enum__ = ValueType;
ValueType.TClass = function(c) { var $x = ["TClass",6,c]; $x.__enum__ = ValueType; $x.toString = $estr; return $x; };
ValueType.TBool = ["TBool",3];
ValueType.TBool.toString = $estr;
ValueType.TBool.__enum__ = ValueType;
ValueType.TObject = ["TObject",4];
ValueType.TObject.toString = $estr;
ValueType.TObject.__enum__ = ValueType;
haxe.StackItem = $hxClasses['haxe.StackItem'] = { __ename__ : ["haxe","StackItem"], __constructs__ : ["CFunction","Module","FilePos","Method","Lambda"] };
haxe.StackItem.Module = function(m) { var $x = ["Module",1,m]; $x.__enum__ = haxe.StackItem; $x.toString = $estr; return $x; };
haxe.StackItem.FilePos = function(s,file,line) { var $x = ["FilePos",2,s,file,line]; $x.__enum__ = haxe.StackItem; $x.toString = $estr; return $x; };
haxe.StackItem.Lambda = function(v) { var $x = ["Lambda",4,v]; $x.__enum__ = haxe.StackItem; $x.toString = $estr; return $x; };
haxe.StackItem.CFunction = ["CFunction",0];
haxe.StackItem.CFunction.toString = $estr;
haxe.StackItem.CFunction.__enum__ = haxe.StackItem;
haxe.StackItem.Method = function(classname,method) { var $x = ["Method",3,classname,method]; $x.__enum__ = haxe.StackItem; $x.toString = $estr; return $x; };
haxe.io.Error = $hxClasses['haxe.io.Error'] = { __ename__ : ["haxe","io","Error"], __constructs__ : ["Blocked","Overflow","OutsideBounds","Custom"] };
haxe.io.Error.Custom = function(e) { var $x = ["Custom",3,e]; $x.__enum__ = haxe.io.Error; $x.toString = $estr; return $x; };
haxe.io.Error.OutsideBounds = ["OutsideBounds",2];
haxe.io.Error.OutsideBounds.toString = $estr;
haxe.io.Error.OutsideBounds.__enum__ = haxe.io.Error;
haxe.io.Error.Overflow = ["Overflow",1];
haxe.io.Error.Overflow.toString = $estr;
haxe.io.Error.Overflow.__enum__ = haxe.io.Error;
haxe.io.Error.Blocked = ["Blocked",0];
haxe.io.Error.Blocked.toString = $estr;
haxe.io.Error.Blocked.__enum__ = haxe.io.Error;

/*
 * Workaround for inheritance of object in old browsers IE8-
 * Where there is no the method Object.create
 */
if (!Object.create) {
	Object.create = function (proto) {
		function F() {}
		F.prototype = proto;
		return new F();
	};
}
